import { defineStore } from 'pinia'
import type { BfApi } from '@library/services'

/** Library API 注入 Store */
export const useBfInjectStore = defineStore('bf-inject', () => {
  let _bfApi: BfApi['bf'] | null = null

  /** 設定 Library API 實例 */
  function setBfApi(value: BfApi['bf']) {
    _bfApi = value
  }

  /** 取得 Library API 實例 */
  function getBfApi(): BfApi['bf'] {
    if (!_bfApi) {
      throw Error('請呼叫 useBfApiStore.setBfApi 方法設定 Library API')
    }

    return _bfApi
  }

  return {
    /** 取得 Library API 實例 */
    getBfApi,
    /** 設定 Library API 實例 */
    setBfApi
  }
})
